/**
 * Genera un UUID v7 (timestamp-based, ordenable cronológicamente).
 * Spec: RFC 9562.
 *
 * Formato: tttttttt-tttt-7xxx-yxxx-xxxxxxxxxxxx
 *   - 48 bits de timestamp (ms desde epoch)
 *   - 4 bits de versión (7)
 *   - 2 bits de variante (10)
 *   - 74 bits aleatorios
 */
export function uuidv7(): string {
  const timestamp = Date.now();
  const timeHex = timestamp.toString(16).padStart(12, '0');

  // 10 bytes aleatorios para los 74 bits de entropía (+ bits de versión/variante).
  const random = new Uint8Array(10);
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(random);
  } else {
    // Fallback inseguro pero funcional (no debería ocurrir en browsers modernos).
    for (let i = 0; i < random.length; i++) {
      random[i] = Math.floor(Math.random() * 256);
    }
  }

  // Set version (7) en el primer nibble del 3er grupo.
  random[0] = ((random[0] ?? 0) & 0x0f) | 0x70;
  // Set variant (10) en los 2 bits altos del 4to grupo.
  random[2] = ((random[2] ?? 0) & 0x3f) | 0x80;

  const hex = Array.from(random, (b) => b.toString(16).padStart(2, '0')).join('');

  return [
    timeHex.slice(0, 8),
    timeHex.slice(8, 12),
    hex.slice(0, 4),
    hex.slice(4, 8),
    hex.slice(8, 20),
  ].join('-');
}
